export class Profile {
  constructor(public name: string, public email: string, public password: string, public phone: string, public createdBy: string,
              public lastLogin: string, public createdDateTime: string,
              public accessLevel: string[], public group: string[]) {
  }

}
